import { useState } from 'react';
import ImageLoader from '../components/ImageLoader'
import Lightbox from '../components/Lightbox';
import ThumbnailPicker from '../components/ThumbnailPicker'


const items = [
    { src:require("../images/interiors/img--interiors-1.jpg").default, caption:"Breezeway Entry", x:708, y:202, width:360, height:245 },
    { src:require("../images/interiors/img--interiors-2.jpg").default, caption:"Living", x:1085, y:202, width:360, height:245 },
    { src:require("../images/interiors/img--interiors-3.jpg").default, caption:"Living", x:1463, y:202, width:360, height:245 },
    { src:require("../images/interiors/img--interiors-4.jpg").default, caption:"Balcony", x:708, y:467, width:360, height:245 },
    { src:require("../images/interiors/img--interiors-5.jpg").default, caption:"Balcony", x:1085, y:467, width:360, height:245 },
    { src:require("../images/interiors/img--interiors-6.jpg").default, caption:"Kitchen Honey", x:1463, y:467, width:360, height:245 },
    { src:require("../images/interiors/img--interiors-7.jpg").default, caption:"Laundry Sunrise", x:708, y:731, width:360, height:245 },
    { src:require("../images/interiors/img--interiors-8.jpg").default, caption:"Bathroom Light Scheme", x:1085, y:731, width:360, height:245 },
    { src:require("../images/interiors/img--interiors-9.jpg").default, caption:"Bathroom Light Scheme", x:1463, y:731, width:360, height:245 },

]


export default function(){
    const [selection, setSelection] = useState<string|null>(null);

    return (
        <div>
            <ThumbnailPicker onSelected={setSelection} items={items}/>
            <Lightbox items={items} selection={selection} onSelected={setSelection} carousel={true}/>
            <ImageLoader src={require("../images/interiors/bkg--interiors-1.jpg").default} />
        </div>
    )
}